import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Add, MoreVert } from '@mui/icons-material';
import { Chip, Divider, IconButton, Menu, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../assets/customIcons';
import { faintGray, gray } from '../../../../theme/palette';
import { Delete, ManageTable, Maximize } from '../../../assets/svg';
import { GridToolbarActionVariants, GridToolbarDefaultActionNames } from '../editableDataGrid.entity';
import ToolbarToggleMenu from './toolbarToggleMenu';
export var EditableGridActions = [
    // {
    //     type: 'Button',
    //     name: GridToolbarDefaultActionNames.AdvanceSearch,
    //     label: 'Advance Search',
    //     children: "Advance Search",
    //     startIcon: <Search />,
    //     checked: false,
    // },
    {
        type: 'Button',
        name: GridToolbarDefaultActionNames.ManageColumns,
        label: "Manage Columns",
        children: "Manage Columns",
        startIcon: /*#__PURE__*/ React.createElement(ManageTable, null),
        checked: false
    },
    // {
    //     type: 'Button',
    //     name: GridToolbarDefaultActionNames.Export,
    //     label: "Export",
    //     children: "Export",
    //     startIcon: <Download />,
    //     endIcon: <ExpandMoreOutlined />,
    //     checked: false,
    // },
    // {
    //     type: 'Button',
    //     name: GridToolbarDefaultActionNames.Upload,
    //     label: "Upload Excel",
    //     children: "Upload Excel",
    //     startIcon: <Upload />,
    //     endIcon: <ExpandMoreOutlined />,
    //     checked: false,
    // },
    {
        type: 'IconButton',
        name: GridToolbarDefaultActionNames.Expand,
        label: 'Expand',
        children: /*#__PURE__*/ React.createElement(Maximize, {
            fontSize: "small"
        }),
        checked: true
    }, {
        type: 'IconButton',
        name: GridToolbarDefaultActionNames.Delete,
        label: 'Delete',
        children: /*#__PURE__*/ React.createElement(Delete, {
            fontSize: "small"
        }),
        checked: true
    }, {
        type: 'Button',
        name: GridToolbarDefaultActionNames.Add,
        label: 'Add',
        startIcon: /*#__PURE__*/ React.createElement(Add, {
            sx: {
                fontSize: 24
            }
        }),
        children: 'Add',
        checked: true
    }
];
export default function EditableGridToolbar(props) {
    var _a = props.isCollapsible, isCollapsible = _a === void 0 ? false : _a, dataGridHeader = props.dataGridHeader, titleTypographyProps = props.titleTypographyProps, chipLabel = props.chipLabel, _b = props.collapse, collapse = _b === void 0 ? false : _b, _c = props.setCollapse, setCollapse = _c === void 0 ? function () { } : _c, _d = props.onToolbarButtonClick, onToolbarButtonClick = _d === void 0 ? function () { } : _d, disableToolbarActions = props.disableToolbarActions, visibleActions = props.visibleActions, actions = props.actions, disableActionsMenu = props.disableActionsMenu;
    var _e = useState(actions !== null && actions !== void 0 ? actions : EditableGridActions), menu = _e[0], setMenu = _e[1];
    var _f = useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var menuOpen = Boolean(anchorEl);
    useEffect(function () {
        setMenu(actions !== null && actions !== void 0 ? actions : EditableGridActions);
    }, [actions]);
    var handleMenuToggle = function (event) {
        setAnchorEl(function (prev) { return prev ? undefined : event.currentTarget; });
    };
    var handleMenuChange = function (e) {
        var name = e.currentTarget.id;
        setMenu(function (prev) { return prev.map(function (it) { return it.name === name ? _objectSpread(_objectSpread({}, it), {}, {
            checked: !it.checked
        }) : it; }); });
    };
    return /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        width: "100%",
        bgcolor: "white",
        px: 2,
        py: 1,
        height: "max-content",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        borderBottom: collapse ? undefined : "1px solid ".concat(faintGray)
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        flexShrink: 0,
        columnGap: 1
    }, isCollapsible && /*#__PURE__*/ React.createElement(IconButton, {
        color: "secondary",
        onClick: function () { return setCollapse(function (prev) { return !prev; }); }
    }, !collapse ? /*#__PURE__*/ React.createElement(ChevronUpIcon, {
        color: "inherit"
    }) : /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        color: "inherit"
    })), dataGridHeader && /*#__PURE__*/ React.createElement(Typography, _extends({
        variant: "h5"
    }, titleTypographyProps), dataGridHeader), chipLabel ? /*#__PURE__*/ React.createElement(Chip, {
        size: "small",
        variant: "outlined",
        color: "info",
        label: chipLabel
    }) : null), !collapse && !disableToolbarActions && /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: "wrap",
        gap: 2,
        color: gray,
        fontWeight: 500,
        textTransform: "none"
    }, menu.map(function (item) {
        if (item.hidden || (visibleActions === null || visibleActions === void 0 ? void 0 : visibleActions[item.name]) === false || !item.checked)
            return null;
        var props = _objectSpread({
            id: item.name,
            color: 'secondary',
            sx: {
                textTransform: 'none'
            },
            onClick: onToolbarButtonClick
        }, item);
        var ToolbarButton = GridToolbarActionVariants[item.type];
        return /*#__PURE__*/ React.createElement(ToolbarButton, _extends({
            key: item.name
        }, props));
    }), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        variant: "middle",
        flexItem: true,
        sx: {
            borderColor: faintGray
        }
    }), !disableActionsMenu && /*#__PURE__*/ React.createElement(IconButton, {
        id: "more-actions-menu-icon",
        onClick: handleMenuToggle
    }, /*#__PURE__*/ React.createElement(MoreVert, null))), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: anchorEl,
        open: menuOpen,
        onClose: handleMenuToggle,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
        }
    }, /*#__PURE__*/ React.createElement(ToolbarToggleMenu, {
        menu: menu,
        visibleActions: visibleActions,
        onClick: handleMenuChange
    })));
}
